import ia from "../../images/tumbResources/ia.jpg";
import learn from "../../images/tumbResources/learn.jpg";
import js from "../../images/tumbResources/js.png";
import png from "../../images/tumbResources/png.jpg";
import game from "../../images/tumbResources/game.webp";
import css from "../../images/tumbResources/css.jpg";

export const resourcesData = [
  {
    title: "Librerías AI para Javascript",
    description: "Conoce estas 5 librerías para hacer Machine Learning con JS",
    img: ia,
    url: "https://www.youtube.com/shorts/KhfjvUhI6qg",
  },
  
  {
    title: "5 Cosas que puedes hacer con Javascript",
    description: "Un repaso a lo que puedes construir con JS",
    img: js,
    url: "https://www.tiktok.com/@keinnerross/video/7145800833437797637?lang=es",
  },

  {
    title: "Aprende a programar gratis",
    description: "Te presento 3 lugares donde aprender programación",
    img: learn,
    url: "https://www.tiktok.com/@keinnerross/video/7147700121239637253?lang=es",
  },

  {
    title: "Plantillas Web para CSS",
    description:
      "Estas plantillas son ideales para cuando no se cuenta con mucho tiempo",
    img: css,
    url: "https://www.youtube.com/shorts/FLT-yjICqZY",
  },

  {
    title: "Sitios para descargar imagenes en PNG ",
    description:
      "Te presento sitios web donde conseguir recursos para tus proyectos",
    img: png,
    url: "https://www.instagram.com/reel/CZuUBHkJwZr/",
  },

  {
    title: "Crea Videojuegos Usando JS ",
    description:
      "Te enseño el resultado que tuve usando Phaser, engine para crear Videojuegos con Javascript",
    img: game,
    url: "https://www.instagram.com/reel/CbBqfDVgJyo/",
  },
];
